
$(document).ready(function() {





  // const buttons = document.querySelectorAll('.tab-buttonps');

  //   buttons.forEach(button => {
  //     button.addEventListener('click', () => {
  //       // Remove 'active' class from all buttons
  //       buttons.forEach(btn => btn.classList.remove('active'));
  //       // Add 'active' class to clicked button
  //       button.classList.add('active');
  //     });
  //   });





  

    $(window).on('scroll', function () {
      var scrollTop = $(this).scrollTop();
      // console.log('Current scroll position: ' + scrollTop);
      if(scrollTop > 130) {
        $('.aa-Panel').remove();
      }
    });
  
    $('.cstm-btn-color-liquid.search__button').click(function() {
      $('.search .aa-Form .aa-SubmitButton').click();
    });

    var subMenuSummary = $('.menu-drawer__submenu summary.menu-drawer__menu-item').length;
    for (var i = 0; i < subMenuSummary; i++) {
      $('.menu-drawer__submenu summary.menu-drawer__menu-item')[i].click();
    }

  function initTabsSlider() {
    const $tabsContainer = $('.coll-tabs-inner .tabs-container-inner');
  
    if (!$tabsContainer.length) return;
  
    if (window.innerWidth < 1050) {
      if (!$tabsContainer.hasClass('slick-initialized')) {
        $('.coll-tabs-inner .cstm_slider').remove();
        $tabsContainer.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight: true,
          arrows: true,
          prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none"> <circle cx="17" cy="17" r="17" transform="rotate(-180 17 17)" fill="#F8F8F8"/> <path d="M18.275 22.9495L12.325 16.9995L18.275 11.0495" stroke="#666666" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/> </svg></button>',
          nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none"> <circle cx="17" cy="17" r="17" fill="#F8F8F8"/> <path d="M15.725 11.0505L21.675 17.0005L15.725 22.9505" stroke="#666666" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/> </svg></button>'
        });
  
        $tabsContainer.on('afterChange', function(event, slick, currentSlide){
          $(`.coll-tabs-inner .tabs-container-inner .tab-button[data-index="${currentSlide+1}"]`).click();
        });
  
        setTimeout(function() {
          $('.coll-tabs-inner .tabs-container-inner .tab-button.slick-active[data-index="1"]').click();
        }, 1000);
      }
      if($('.cstm_banner_mob .cstm_banner_boxes')) {
        $('.cstm_banner_mob .cstm_banner_boxes').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: true,
            dots: true,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 3000
          });
      }
    } else {
      if ($tabsContainer.hasClass('slick-initialized')) {
        $tabsContainer.slick('unslick');
      }
      if ($('.cstm_banner_mob .cstm_banner_boxes').hasClass('slick-initialized')) {
        $('.cstm_banner_mob .cstm_banner_boxes').slick('unslick');
      }
    }
  }

  initTabsSlider();
  $(window).on('resize', function() {
    initTabsSlider();
  });
  
  if($('body').hasClass('template-collection') || $('body').hasClass('template-search')) {

     $('.cstm_filter_coll_close').click(function () {
       $('.mobile-facets__close').click();
     });

    $('.cstm_readMore_btn').click(function(event) {
      event.preventDefault();
      $('.cstm_coll_desc_truncate').hide();
      $('.cstm_coll_desc_full').show();
    });

    $('.cstm_collapse_btn').click(function(event) {
      event.preventDefault();
      $('.cstm_coll_desc_truncate').show();
      $('.cstm_coll_desc_full').hide();
    });
    
  }

  function multiRowSlick() {
    const $slider = $('.AboutUs .multirow__inner');
    
    if (window.innerWidth < 550) {
      if (!$slider.hasClass('slick-initialized')) {
        $slider.slick({
          adaptiveHeight: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true
        });
      }
    } else {
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }
    }
  }

  // Call once on load
  multiRowSlick();

  // Call again on resize
  window.addEventListener("resize", multiRowSlick);


  $('.cstm-box-contai .view-more a').click(function(e) {
    e.preventDefault();
    if($(this).hasClass('view-less')) {
      $(this).removeClass('view-less');
      $('.cstm_more_view').addClass('cstm_hide');
      $(this).html('view more <img src="https://cdn.shopify.com/s/files/1/0629/3402/4343/files/Rectangle_2811_1.svg?v=1708415796" />');
    } else {
      $(this).addClass('view-less');
      $('.cstm_more_view').removeClass('cstm_hide');
      $(this).html('view less <img src="https://cdn.shopify.com/s/files/1/0629/3402/4343/files/Rectangle_2811.svg?v=1708415796" />');
    }
  });

  if($('body').hasClass('template-customers-login')) {

     $('.cstm-sign-div a').click(function (e) {
       e.preventDefault();
       $('.cstm_login_wrapper').removeClass('active');
       $('.cstm_reset_password').addClass('active');
     });

     $('.cancel-submuit-btn').click(function (e) {
       e.preventDefault();
       $('.cstm_reset_password').removeClass('active');
       $('.cstm_login_wrapper').addClass('active');
     });
    
  }

  if($('body').hasClass('template-customers-register')) {
    const form = document.getElementById('custom_registration_form');
    const fields = document.querySelectorAll('.fieldWrapper');
    const nextBtn = document.querySelector('.class_next');
    const prevBtn = document.querySelector('.class_pre');
    const changeText = document.querySelector('.cstm_change_text');
    const sbmtbtn = document.querySelector('.submitButtonWrapper');
    const span1 = document.querySelector('.dot-1');
    const span2 = document.querySelector('.dot-2');
    const span3 = document.querySelector('.dot-3');
    let currentPage = 1;
    let buttonText = ["Company Information (optional)", "Shipping Information"];
    $('.sbmtbtn').click(function() {
        setTimeout(function() {
            window.location.href = 'https://systainer.myshopify.com/pages/account-successful';
        }, 2000); // 2000 milliseconds = 2 seconds
    });
    if (currentPage === 1) {
        span1.classList.add('color_blue');
        span2.classList.remove('color_blue');
        span3.classList.remove('color_blue');
        nextBtn.classList.add('color_blue');
        prevBtn.classList.add('cstm_none_use');
        nextBtn.classList.remove('cstm_none_use');
        sbmtbtn.classList.add('cstm_none_use');
    }
    
    function navigateToPage(pageNumber) {
        showPage(pageNumber);
        changeText.innerHTML = buttonText[(pageNumber - 1)] || "Personal Information";
        switch (pageNumber) {
            case 1:
                prevBtn.classList.add('cstm_none_use');
                nextBtn.classList.remove('cstm_none_use');
                span1.classList.add('color_blue');
                span2.classList.remove('color_blue');
                span3.classList.remove('color_blue');
                sbmtbtn.classList.add('cstm_none_use');
                break;
            case 2:
                prevBtn.classList.remove('cstm_none_use');
                nextBtn.classList.remove('cstm_none_use');
                span1.classList.remove('color_blue');
                span2.classList.add('color_blue');
                span3.classList.remove('color_blue');
                sbmtbtn.classList.add('cstm_none_use');
                break;
            case 3:
                prevBtn.classList.remove('cstm_none_use');
                nextBtn.classList.add('cstm_none_use');
                span1.classList.remove('color_blue');
                span2.classList.remove('color_blue');
                span3.classList.add('color_blue');
                sbmtbtn.classList.remove('cstm_none_use');
                break;
        }
    }
    span1.addEventListener('click', function(e) {
        currentPage = 1;
        navigateToPage(currentPage);
    });
    span2.addEventListener('click', function(e) {
        currentPage = 2;
        navigateToPage(currentPage);
        nextBtn.classList.add('color_blue');
    });
    span3.addEventListener('click', function(e) {
        currentPage = 3;
        navigateToPage(currentPage);
    });
    
    function navigateToPage(pageNumber) {
        currentPage = pageNumber;
        showPage(currentPage);
        switch (pageNumber) {
            case 1:
                changeText.innerHTML = "Personal Information";
                prevBtn.classList.remove('color_blue');
                nextBtn.classList.add('color_blue');
                nextBtn.classList.remove('cstm_none_use');
                prevBtn.classList.add('cstm_none_use');
                span1.classList.add('color_blue');
                span2.classList.remove('color_blue');
                span3.classList.remove('color_blue');
                sbmtbtn.classList.add('cstm_none_use');
                break;
            case 2:
                changeText.innerHTML = "Company Information (optional)";
                prevBtn.classList.add('color_blue');
                nextBtn.classList.add('color_blue');
                nextBtn.classList.remove('cstm_none_use');
                prevBtn.classList.remove('cstm_none_use');
                span1.classList.remove('color_blue');
                span2.classList.add('color_blue');
                span3.classList.remove('color_blue');
                sbmtbtn.classList.add('cstm_none_use');
                break;
            case 3:
                changeText.innerHTML = "Shipping Information";
                prevBtn.classList.add('color_blue');
                nextBtn.classList.remove('color_blue');
                nextBtn.classList.add('cstm_none_use');
                span1.classList.remove('color_blue');
                span2.classList.remove('color_blue');
                span3.classList.add('color_blue');
                sbmtbtn.classList.remove('cstm_none_use');
                break;
        }
    }
    
    function showPage(pageNumber) {
        let startIndex, endIndex;
        if (pageNumber === 1) {
            startIndex = 0;
            endIndex = 4;
        } else {
            startIndex = 4 + (pageNumber - 2) * 5;
            endIndex = startIndex + 5;
        }
        fields.forEach((field, index) => {
            if (index >= startIndex && index < endIndex) {
                field.classList.remove('hidden');
            } else {
                field.classList.add('hidden');
            }
        });
    }
    nextBtn.addEventListener('click', function(e) {
        nextBtn.classList.remove('color_blue');
        prevBtn.classList.add('color_blue');
        prevBtn.classList.remove('cstm_none_use');
        e.preventDefault();
        currentPage++;
        showPage(currentPage);
        changeText.innerHTML = buttonText[(currentPage - 2)] || "Shipping Information";
        if (currentPage > 1) {
            prevBtn.classList.add('color_blue');
            nextBtn.classList.add('color_blue');
            nextBtn.classList.remove('cstm_none_use');
            span1.classList.remove('color_blue');
            span2.classList.add('color_blue');
            span3.classList.remove('color_blue');
            sbmtbtn.classList.add('cstm_none_use');
        } else {
            prevBtn.classList.remove('color_blue');
            nextBtn.classList.remove('cstm_none_use');
            span1.classList.remove('color_blue');
            span2.classList.add('color_blue');
            span3.classList.remove('color_blue');
            sbmtbtn.classList.add('cstm_none_use');
        }
        // Check if current page is the last page
        const totalPages = 3; // Total number of pages is now fixed to 3
        if (currentPage === totalPages) {
            nextBtn.classList.remove('color_blue');
            nextBtn.classList.add('cstm_none_use');
            span1.classList.remove('color_blue');
            span2.classList.remove('color_blue');
            span3.classList.add('color_blue');
            sbmtbtn.classList.remove('cstm_none_use');
        } else {
            nextBtn.classList.add('color_blue');
            nextBtn.classList.remove('cstm_none_use');
            span1.classList.remove('color_blue');
            span2.classList.add('color_blue');
            span3.classList.remove('color_blue');
            sbmtbtn.classList.add('cstm_none_use');
        }
    });
    prevBtn.addEventListener('click', function(e) {
        e.preventDefault();
        if (currentPage > 1) {
            currentPage--;
            showPage(currentPage);
            if (currentPage === 1) {
                changeText.innerHTML = "Personal Information";
                prevBtn.classList.remove('color_blue');
                nextBtn.classList.remove('cstm_none_use');
                prevBtn.classList.add('cstm_none_use');
                span1.classList.add('color_blue');
                span2.classList.remove('color_blue');
                sbmtbtn.classList.add('cstm_none_use');
                span3.classList.remove('color_blue');
            } else if (currentPage === 2) {
                changeText.innerHTML = "Company Information (optional)";
                prevBtn.classList.add('color_blue');
                nextBtn.classList.remove('cstm_none_use');
                span1.classList.remove('color_blue');
                span2.classList.add('color_blue');
                span3.classList.remove('color_blue');
                sbmtbtn.classList.add('cstm_none_use');
            } else if (currentPage === 3) {
                changeText.innerHTML = "Shipping Information";
                prevBtn.classList.add('color_blue');
                nextBtn.classList.remove('cstm_none_use');
                span1.classList.remove('color_blue');
                span2.classList.remove('color_blue');
                span3.classList.add('color_blue');
                sbmtbtn.classList.remove('cstm_none_use');
            }
            nextBtn.classList.add('color_blue');
        }
    });
    // Initially show the first page
    showPage(currentPage);
    var firstElement = document.querySelectorAll('.copyright__content')[0];
    firstElement.innerHTML = "© 2021 - 2024 TANOS GmbH All rights reserved.";
  }

  if($('body').hasClass('contact')) {

     if(window.location.href.indexOf('contact_posted=true#ContactForm') > -1) {
        $('.cstm_contact_form_fields').removeClass('active');
        $('.cstm_contact_form_submission').addClass('active');
        $('#ContactForm').css('min-height', '546px');
        $('#ContactForm').css('display', 'flex');
        $('#ContactForm').css('align-items', 'center');
    }
    
  }

  if($('body').hasClass('template-product') && !$('body').hasClass('legacy-product-template')) {

    function checkDisabledOptions() {
        let hasDisabledOption = false;
        
        if($('.product-form__input input[type="radio"]').length > 0) {
          $('.product-form__input input[type="radio"]:checked').each(function() {
              // Check if its parent has the 'disabled' class
              if ($(this).closest('.disabled').length) {
                  hasDisabledOption = true;
                  $('.cstm_ofs').remove();
                  $('.product__text').after('<span class="mbl_sold_out_badg cstm_ofs"> Sold Out </span>');
                  $('.mbl_main_title_sec > h2').before('<span class="mbl_sold_out_badg cstm_ofs"> Sold Out </span>');
                  return false; // Exit the loop if a disabled option is found
              }
          });
        } else {
          if ($('.product-form__submit').is(':disabled')) {
              hasDisabledOption = true;
          }
        }
        
        if (hasDisabledOption) {
          $('.product-form__submit').attr("disabled", "disabled");
          $('.product-form__submit span').text('Sold out');
          $('.template-product .product__info-container.product__column-sticky .product-form__input.product-form__quantity').hide();
          $('.custom_btn_buy').hide();
          $('.cstm_notify_me').show();
        } else {
          $('.product-form__submit').removeAttr("disabled");
          $('.product-form__submit span').text('Add to cart');
          $('.template-product .product__info-container.product__column-sticky .product-form__input.product-form__quantity').show();
          $('.custom_btn_buy').show();
          $('.cstm_notify_me').hide();
          $('.cstm_ofs').remove();
        }
    }

    $('.product-form__input .cstm_var_sel_wrapper').mouseenter(function() {
      if ($(this).hasClass('disabled')) {
        $(this).addClass('cstm_notAvailable');
      }
    }).mouseleave(function() {
      if ($(this).hasClass('disabled')) {
        $(this).removeClass('cstm_notAvailable');
      }
    });

    
    $('.product-form__input input[type="radio"]').click(function() {
      
      // $('.product-form__input .cstm_var_sel_wrapper').removeClass('cstm_notAvailable');
      // if($(this).parent().hasClass('disabled')) {
      //   $(this).parent().addClass('cstm_notAvailable');
      // }
      
      setTimeout(function() {
        checkDisabledOptions();
      }, 600);
      
      $(this).parent().parent().parent().find('legend.form__label span').remove();
      var comColor = $(this).parent().parent().parent().find('legend.form__label').text();
      var clickColor = $(this).attr('value');
      $(this).parent().parent().parent().find('legend.form__label').html(`${comColor}<span>&nbsp;&nbsp;&nbsp;&nbsp;${clickColor}</span>`);

      $('.ps-accordion-item').removeClass('selected');
      $('.ps-accordion-item .ps-icon-button').html('<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M11 2V20" stroke="white" stroke-width="3" stroke-linecap="round"/> <path d="M20 11L2 11" stroke="white" stroke-width="3" stroke-linecap="round"/> </svg>');
      $('.ps-accordion-item .ps-icon-button').removeClass('minus');
      $('.ps-accordion-item .ps-icon-button').addClass('plus');
      // $('.template-product .product__info-container.product__column-sticky .custom_btn_buy .product-form__submit span').text(`Add to Cart`);
      $('.ps-accordion-content').hide();

      var rect = this.getBoundingClientRect();
      var tooltipWidth = 256;
      
      if (rect.left < 0) {
          console.log('Tooltip is off the left edge');
          $(this).parent().css('--tooltip-left', '10px');
      } else if (rect.right + tooltipWidth > $(window).width()) {
          console.log('Tooltip is off the right edge');
          $(this).parent().css('--tooltip-left', ($(window).width() - rect.right - 280) + 'px');
      } else {
          console.log('Tooltip is fine');
          $(this).parent().css('--tooltip-left', '50%');
      }

      
      
      
      setTimeout(function() {
          var urlParams = new URLSearchParams(window.location.search);
          var variantId = urlParams.get('variant');
          if (variantId) {
            var variantsData = JSON.parse(document.querySelector('variant-selects script[type="application/json"]').textContent);
            var matchingVariant = variantsData.find(variant => variant.id === parseInt(variantId, 10));
            if (matchingVariant) {
                // Convert price to dollars and format it as currency
                var formattedPrice = (matchingVariant.price / 100).toLocaleString("en-US", {
                    style: "currency",
                    currency: Shopify.currency.active
                });
                var formattedComPrice = (matchingVariant.compare_at_price / 100).toLocaleString("en-US", {
                    style: "currency",
                    currency: Shopify.currency.active
                });
                console.log(matchingVariant);
                $('.cstm_prd_price_wrapper .cstm_normal_price').text(formattedPrice);
                $('.cstm_prd_price_wrapper .cstm_cut_price').text(formattedComPrice);
                $('.product-price-mbl-real').text(formattedPrice);
                $('.product-price-mbl-compare-at').text(formattedComPrice);
                if (matchingVariant.compare_at_price > matchingVariant.price) {
                  $('.cstm_prd_price_wrapper .cstm_normal_price').addClass('cstm_green');
                  $('.cstm_prd_price_wrapper .cstm_cut_price').removeClass('cstm_hide');
                  $('.product-price-mbl-compare-at').removeClass('cstm_hide');
                  $('.cstm_sale_badge').removeClass('cstm_hide');
                } else {
                  $('.cstm_prd_price_wrapper .cstm_normal_price').removeClass('cstm_green');
                  $('.cstm_prd_price_wrapper .cstm_cut_price').addClass('cstm_hide');
                  $('.product-price-mbl-compare-at').addClass('cstm_hide');
                  $('.cstm_sale_badge').addClass('cstm_hide');
                }
            } else {
                console.log("No matching variant found for ID:", variantId);
            }
        }
      }, 400);
      
      
    });

    checkDisabledOptions();

    $('.product-form__input .cstm_var_sel_wrapper').mouseenter(function() {
        $(this).addClass('cstm_colorHover');
    }).mouseleave(function() {
        $(this).removeClass('cstm_colorHover');
    });

    $('.ps-accordion-header').click(function() {
      var totalVar = $(this).parent().find('.cstm_recommended_accessories_variants option').length;
      if($(this).find('.ps-icon-button').hasClass('plus')) {
        $(this).find('.ps-icon-button').html('<svg width="22" height="4" viewBox="0 0 22 4" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M20 2L2 2" stroke="#666666" stroke-width="3" stroke-linecap="round"/> </svg>');
        $(this).find('.ps-icon-button').removeClass('plus');
        $(this).find('.ps-icon-button').addClass('minus');
        $(this).parent().find('.ps-accordion-content').show();
        var selectedVal = $(this).parent().find('.cstm_recommended_accessories_variants').val();
        $(this).find('.ps-icon-button').attr('data-variant-id', selectedVal);
        $(this).parent().addClass('selected');
      } else {
        $(this).find('.ps-icon-button').html('<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M11 2V20" stroke="white" stroke-width="3" stroke-linecap="round"/> <path d="M20 11L2 11" stroke="white" stroke-width="3" stroke-linecap="round"/> </svg>');
        $(this).find('.ps-icon-button').removeClass('minus');
        $(this).find('.ps-icon-button').addClass('plus');
        $(this).parent().find('.ps-accordion-content').hide();
        var selectedVal = $(this).parent().find('.cstm_recommended_accessories_variants').val();
        $(this).find('.ps-icon-button').attr('data-variant-id', '');
        $(this).parent().removeClass('selected');
        $(this).parent().removeClass('success');
      }
      var totalSelected = $('.ps-accordion-item.selected').length;
      if(totalSelected >= 1) {
        if($('.product-form__submit').is(':disabled')) {
          $('.template-product .product__info-container.product__column-sticky .custom_btn_buy .product-form__submit span').text(`(${totalSelected+1}) Sold out`);
        } else {
          $('.template-product .product__info-container.product__column-sticky .custom_btn_buy .product-form__submit span').text(`(${totalSelected+1}) Add to cart`);
        }
      } else {
        if($('.product-form__submit').is(':disabled')) {
          $('.template-product .product__info-container.product__column-sticky .custom_btn_buy .product-form__submit span').text(`Sold out`);
        } else {
          $('.template-product .product__info-container.product__column-sticky .custom_btn_buy .product-form__submit span').text(`Add to cart`);
        }
      }
      
    });

    $('.ps-product-options select').change(function() {
      var selectElements = $(this).parent().parent().find('select');
      var valuesArray = [];
      for (var i = 0; i < selectElements.length; i++) {
          valuesArray.push(selectElements[i].value);
      }
      var concatenatedValues = valuesArray.join(' / ');
      
      // Find the matching option
      var matchingOption = $(this).parent().parent().parent().parent().find(".cstm_recommended_accessories_variants option").filter(function() {
          return $(this).text() === concatenatedValues;
      });
  
      // Check if the matching option is disabled
      if (matchingOption.prop('disabled')) {
          console.log("The selected option is disabled.");
          $(this).parent().parent().parent().parent().find('.cstm_error').remove();
          $(this).parent().parent().parent().parent().append('<div class="cstm_error">This variant option is out of stock. Please select another one.</div>');
      } else {
          matchingOption.prop('selected', true);
          $(this).parent().parent().parent().parent().find('.cstm_error').remove();
          var selectedVal = $(this).parent().parent().parent().parent().find(".cstm_recommended_accessories_variants").val();
          $(this).parent().parent().parent().parent().find(".ps-icon-button").attr('data-variant-id', selectedVal);
      }
    });


    $('.template-product .product__info-container.product__column-sticky .custom_btn_buy .product-form__submit').click(function(event) {
      if($('.ps-accordion-container').length >= 1) {
        
        if($('.ps-accordion-item.success').length >= 1) {
          $('.ps-accordion-item.success').removeClass('success');
        } else if($('.ps-accordion-item.selected:not(.success)').length >= 1) {
          event.preventDefault();
          var variantIds = [];
          $('.ps-accordion-item.selected .ps-icon-button').each(function() {
            var variantId = $(this).attr('data-variant-id');
            if ($.inArray(variantId, variantIds) === -1) {
              variantIds.push(variantId);
            }
          });
          var items = variantIds.map(function(variantId) {
            return {
              quantity: 1,
              id: variantId
            };
          });
          $.post('/cart/add.js', {
            items: items
          })
          .done(function(response) {
            console.log('Response:', response);
            $('.ps-accordion-item.selected').addClass('success');
            $('.ps-accordion-item').removeClass('selected');
            $('.ps-accordion-item .ps-icon-button').html('<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M11 2V20" stroke="white" stroke-width="3" stroke-linecap="round"/> <path d="M20 11L2 11" stroke="white" stroke-width="3" stroke-linecap="round"/> </svg>');
            $('.ps-accordion-item .ps-icon-button').removeClass('minus');
            $('.ps-accordion-item .ps-icon-button').addClass('plus');
            $('.template-product .product__info-container.product__column-sticky .custom_btn_buy .product-form__submit span').text(`Add to Cart`);
            $('.ps-accordion-content').hide();
            setTimeout(function() {
              $('.template-product .product__info-container.product__column-sticky .custom_btn_buy .product-form__submit').click();
            }, 1500);
          })
          .fail(function(error) {
            console.error('Error:', error);
          });
        } else {
          
        }
      }
    });

    $('.product__media-toggle').click(function(event) {
      event.preventDefault();
      // var getclickedThumbnailIndex = $(this).parent().parent().parent().parent().parent().next().find('.thumbnail-list__item.slider__slide .thumbnail[aria-current]').parent().index('.thumbnail-list > li:visible');
      // console.log(getclickedThumbnailIndex+1);
      var getclickedThumbnailIndex = $(this).attr('data-media-id');
      $('.product-media-modal__content').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        dots: false,
        autoplay: false,
        infinite: false,
        arrows: false,
        draggable: false,
        swipe: false
      });

      // Function to move to the next available slide with 'active' or 'cstm_GPI' class
      function goToNextAvailableSlide(direction) {
          var $slickSlider = $('.product-media-modal__content');
          var currentSlide = $slickSlider.slick('slickCurrentSlide');
          var totalSlides = $slickSlider.slick('getSlick').slideCount;
          
          // Define the variable to track the next slide
          var nextSlide = currentSlide;
          
          // Loop to find the next or previous slide with the class
          do {
              // Increment or decrement slide index based on direction
              nextSlide = direction === 'next' ? (nextSlide + 1) % totalSlides : (nextSlide - 1 + totalSlides) % totalSlides;
              
              // Check if the next/previous slide has the required classes
              var $nextSlide = $slickSlider.find('.slick-slide[data-slick-index="' + nextSlide + '"]');
              var hasClass = $nextSlide.hasClass('active') || $nextSlide.hasClass('cstm_GPI');
              
              if (hasClass) {
                  // If the slide has the required class, move to it
                  $slickSlider.slick('slickGoTo', nextSlide);
                  return;
              }
              
              // Exit condition: If we've looped all the way around and come back to the current slide, stop
          } while (nextSlide !== currentSlide);

      }
      
      // Event listener for the custom next arrow
      $('.cstm_next_arrow').click(function(event) {
          event.preventDefault();   // Prevent default behavior
          console.log('Next Slide');
          goToNextAvailableSlide('next');
          (function () {
            const videoPlayers = document.querySelector('.product-media-modal__content');
            if (!videoPlayers) return;

            /* 1. Pause all HTML5 videos */
            const htmlVideos = videoPlayers.querySelectorAll('video');
            htmlVideos.forEach(video => {
              try {
                video.pause();
              } catch (e) {}
            });

            /* 2. Pause YouTube iframes */
            const ytIframes = videoPlayers.querySelectorAll('iframe[src*="youtube.com"], iframe[src*="youtu.be"]');
            ytIframes.forEach(iframe => {
              iframe.contentWindow?.postMessage(
                JSON.stringify({
                  event: 'command',
                  func: 'pauseVideo',
                  args: []
                }),
                '*'
              );
            });

            /* 3. Pause Vimeo iframes */
            const vimeoIframes = videoPlayers.querySelectorAll('iframe[src*="vimeo.com"]');
            vimeoIframes.forEach(iframe => {
              iframe.contentWindow?.postMessage(
                JSON.stringify({
                  method: 'pause'
                }),
                '*'
              );
            });
          })();
      });
      
      // Event listener for the custom previous arrow
      $('.cstm_prev_arrow').click(function(event) {
          event.preventDefault();   // Prevent default behavior
          console.log('Prev Slide');
          goToNextAvailableSlide('prev');
          (function () {
            const videoPlayers = document.querySelector('.product-media-modal__content');
            if (!videoPlayers) return;

            /* 1. Pause all HTML5 videos */
            const htmlVideos = videoPlayers.querySelectorAll('video');
            htmlVideos.forEach(video => {
              try {
                video.pause();
              } catch (e) {}
            });

            /* 2. Pause YouTube iframes */
            const ytIframes = videoPlayers.querySelectorAll('iframe[src*="youtube.com"], iframe[src*="youtu.be"]');
            ytIframes.forEach(iframe => {
              iframe.contentWindow?.postMessage(
                JSON.stringify({
                  event: 'command',
                  func: 'pauseVideo',
                  args: []
                }),
                '*'
              );
            });

            /* 3. Pause Vimeo iframes */
            const vimeoIframes = videoPlayers.querySelectorAll('iframe[src*="vimeo.com"]');
            vimeoIframes.forEach(iframe => {
              iframe.contentWindow?.postMessage(
                JSON.stringify({
                  method: 'pause'
                }),
                '*'
              );
            });
          })();
      });

      var moveSlickSlide = $(`.product-media-modal__content .global-media-settings[data-media-id="${getclickedThumbnailIndex}"]`).attr('data-slick-index');
      $('.product-media-modal__content').slick('slickGoTo', moveSlickSlide);

      // // Function to click the custom next arrow with a delay
      // function clickArrowWithDelay(times, delay) {
      //   for (let i = 0; i < times; i++) {
      //     setTimeout(function() {
      //       $('.cstm_next_arrow').click(); // Simulate the click using jQuery
      //     }, i * delay); // Delay between each click
      //   }
      // }
      
      // if(getclickedThumbnailIndex > 1) {
      //   clickArrowWithDelay(getclickedThumbnailIndex, 800);
      // }
      
    });

    $('.product-media-modal__toggle').click(function(event) {
      event.preventDefault();
      $('.product-media-modal').attr('open', false);
      $('.product-media-modal__content').slick('unslick');
      (function () {
        const videoPlayers = document.querySelector('.product-media-modal__content');
        if (!videoPlayers) return;

        /* 1. Pause all HTML5 videos */
        const htmlVideos = videoPlayers.querySelectorAll('video');
        htmlVideos.forEach(video => {
          try {
            video.pause();
          } catch (e) {}
        });

        /* 2. Pause YouTube iframes */
        const ytIframes = videoPlayers.querySelectorAll('iframe[src*="youtube.com"], iframe[src*="youtu.be"]');
        ytIframes.forEach(iframe => {
          iframe.contentWindow?.postMessage(
            JSON.stringify({
              event: 'command',
              func: 'pauseVideo',
              args: []
            }),
            '*'
          );
        });

        /* 3. Pause Vimeo iframes */
        const vimeoIframes = videoPlayers.querySelectorAll('iframe[src*="vimeo.com"]');
        vimeoIframes.forEach(iframe => {
          iframe.contentWindow?.postMessage(
            JSON.stringify({
              method: 'pause'
            }),
            '*'
          );
        });
      })();
    });

    // $('.cstm_zoom_in').click(function(event) {
    //     event.preventDefault();
    //     $('.product__media-list .product__media-item .product__media img').addClass('zoom-active');
    //     $(this).attr('style', 'display: none !important;');
    //     $('.cstm_zoom_out').attr('style', 'display: block !important;');
      
    //     let isDragging = false;
    //     let startX, startY, translateX = 0, translateY = 0;
    
    //     function startDrag(e) {
    //         isDragging = true;
    
    //         // Handle touch events
    //         if (e.type === 'touchstart') {
    //             startX = e.touches[0].pageX;
    //             startY = e.touches[0].pageY;
    //         } else {
    //             startX = e.pageX;
    //             startY = e.pageY;
    //         }
    
    //         // Prevent image selection while dragging
    //         e.preventDefault();
    //     }
    
    //     function drag(e) {
    //         if (!isDragging) return;
    
    //         let moveX, moveY;
    
    //         if (e.type === 'touchmove') {
    //             moveX = e.touches[0].pageX - startX;
    //             moveY = e.touches[0].pageY - startY;
    //         } else {
    //             moveX = e.pageX - startX;
    //             moveY = e.pageY - startY;
    //         }
    
    //         translateX += moveX;
    //         translateY += moveY;
    
    //         $('.product__media-list .product__media-item .product__media img.zoom-active').css({
    //             'transform': `translateX(-50%) translateY(-50%) translate(${translateX}px, ${translateY}px)`
    //         });
    
    //         startX += moveX;
    //         startY += moveY;
    //     }
    
    //     function endDrag() {
    //         isDragging = false;
    //     }
    
    //     // Start dragging on mouse down or touch start
    //     $('.product__media-list .product__media-item .product__media img.zoom-active').on('mousedown touchstart', startDrag);
    
    //     // Handle dragging movement on mouse move or touch move
    //     $(document).on('mousemove touchmove', drag);
    
    //     // Stop dragging on mouse up or touch end
    //     $(document).on('mouseup touchend', endDrag);
    // });





    // $('.cstm_zoom_out').click(function(event) {
    //   event.preventDefault();
    //   $('.product__media-list .product__media-item .product__media img').removeClass('zoom-active');
    //   $(this).attr('style', 'display: none !important;');
    //   $('.cstm_zoom_in').attr('style', 'display: block !important;');
    // });

     $('.cstm_notify_me').click(function(event) {
        event.preventDefault();
        $('.product-popup').addClass('active');
        $('.product-popups').addClass('active');
        $('.descrpition-popup button.wizard__submit[type="submit"]').click(function(event) {
          // event.preventDefault();
          console.log('Clicked Notify Submit');
          const customerEmail = $('.descrpition-popup .globo-form-input input[data-type="email"]').val();
          const variantId = $('.custom_btn_buy form.form .product-variant-id').val();
          const companyId = "Uw9hV7";
          
          const payload = {
            "data": {
              "type": "back-in-stock-subscription",
              "attributes": {
                "profile": {
                  "data": {
                    "type": "profile",
                    "attributes": {
                      "email": customerEmail
                    }
                  }
                },
                "company_id": companyId,
                "channels": ["EMAIL"],
              },
              "relationships": {
                "variant": {
                  "data": {
                    "type": "catalog-variant",
                    "id": `$shopify:::$default:::${variantId}`
                  }
                }
              }
            }
          };
          
          var requestOptions = {
              method: 'POST',
              headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer Uw9hV7",
                "revision": "2024-06-15"
              },
              body: JSON.stringify(payload),
          };
          
          fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/", requestOptions)
              .then(response => {
                  // Log the response status and the raw response
                  console.log("Response status:", response.status);
                  return response.text();
              })
              .then(text => {
                  // Attempt to parse as JSON
                  try {
                      const result = JSON.parse(text);
                      console.log("Successfully subscribed:", result);
                  } catch (error) {
                      console.error("Error parsing JSON:", error);
                      console.log("Raw response:", text);
                  }
              })
              .catch(error => console.error('Fetch error:', error));
        });
      });

    $('.exit-svg-popup').click(function() {
      $('.product-popup').removeClass('active');
      $('.product-popups').removeClass('active');
      // Clear email input if it exists
      if ($('.descrpition-popup .globo-form-input input[data-type="email"]').length) {
        $('.descrpition-popup .globo-form-input input[data-type="email"]').val('');
      }
      
      // Clear text input if it exists
      if ($('.descrpition-popup .globo-form-input input[data-type="text"]').length) {
        $('.descrpition-popup .globo-form-input input[data-type="text"]').val('');
      }
      
      // Uncheck checkbox if it exists
      if ($('.descrpition-popup .globo-form-input input[data-type="checkbox"]').length) {
        $('.descrpition-popup .globo-form-input input[data-type="checkbox"]').prop('checked', false);
      }

      Globo.FormBuilder.initialize();
    });

    // Product images slider - iPhone + Android
    if(window.innerWidth < 600) {
        
        // ========== iOS SPECIFIC FIX ==========
        // Function to fix iPhone alignment issues
        // Global variable to prevent infinite loops
        let iosAlignmentLock = false;
        let lastAlignmentTime = 0;

        function fixIOSSlideAlignment() {
            // Prevent multiple simultaneous corrections
            if (iosAlignmentLock || (Date.now() - lastAlignmentTime) < 50) {
                return;
            }
            
            // Only run on iOS
            if (!(/iPhone|iPad|iPod/.test(navigator.platform))) {
                return;
            }
            
            const slider = document.querySelector('.product__media-list');
            if (!slider) return;
            
            iosAlignmentLock = true;
            
            // Get slider dimensions
            const sliderRect = slider.getBoundingClientRect();
            const sliderWidth = sliderRect.width;
            const sliderCenter = sliderRect.left + sliderWidth / 2;
            
            // Find the slide closest to center
            const slides = slider.children;
            let targetSlide = null;
            let targetIndex = -1;
            let minDistance = Infinity;
            
            for (let i = 0; i < slides.length; i++) {
                const slide = slides[i];
                const rect = slide.getBoundingClientRect();
                
                if (rect.width === 0) continue;
                
                const slideCenter = rect.left + rect.width / 2;
                const distance = Math.abs(slideCenter - sliderCenter);
                
                if (distance < minDistance) {
                    minDistance = distance;
                    targetSlide = slide;
                    targetIndex = i;
                }
            }
            
            if (targetSlide && minDistance > 1) {
                console.log(`iOS: Perfect alignment for slide ${targetIndex}, offset: ${minDistance.toFixed(1)}px`);
                
                // CALCULATION 1: Get slide's exact visual position
                const slideRect = targetSlide.getBoundingClientRect();
                
                // CALCULATION 2: Calculate EXACT pixel-perfect scroll position
                // This ensures the slide is perfectly centered
                const slideLeftInSlider = slideRect.left - sliderRect.left;
                const slideWidth = slideRect.width;
                
                // Formula: scroll to position where (slideLeftInSlider = (sliderWidth - slideWidth) / 2)
                const currentScroll = slider.scrollLeft;
                const targetScroll = currentScroll + (slideLeftInSlider - (sliderWidth - slideWidth) / 2);
                
                // Round to nearest pixel to avoid subpixel issues
                const roundedTargetScroll = Math.round(targetScroll);
                
                // Apply the correction with multiple methods for reliability
                applyIOSScrollCorrection(slider, roundedTargetScroll, targetIndex);
            }
            
            iosAlignmentLock = false;
            lastAlignmentTime = Date.now();
        }
        
        function applyIOSScrollCorrection(slider, targetScroll, slideIndex) {
          // Store current scroll behavior
          const originalScrollBehavior = slider.style.scrollBehavior;
          
          // Method 1: Direct assignment (most reliable)
          slider.scrollLeft = targetScroll;
          
          // Method 2: Force a reflow and check
          setTimeout(() => {
              if (Math.abs(slider.scrollLeft - targetScroll) > 1) {
                  console.log(`iOS: Re-applying correction (diff: ${Math.abs(slider.scrollLeft - targetScroll)}px)`);
                  slider.scrollLeft = targetScroll;
              }
          }, 10);
          
          // Method 3: Final verification
          setTimeout(() => {
              if (Math.abs(slider.scrollLeft - targetScroll) > 1) {
                  console.log(`iOS: Final correction needed`);
                  
                  // Use scrollTo as last resort
                  slider.scrollTo({
                      left: targetScroll,
                      behavior: 'auto'
                  });
              }
              
              // Apply CSS adjustment for perfect visual centering
              applyIOSVisualAdjustment(slideIndex);
          }, 50);
      }

      function applyIOSVisualAdjustment(slideIndex) {
          const slides = document.querySelectorAll('.product__media-list > li');
          
          // Remove all adjustment classes first
          slides.forEach(slide => {
              slide.classList.remove('cstm_iPhone_margin');
              slide.style.transform = '';
              slide.style.marginLeft = '';
          });
          
          // Apply adjustment to current slide (except first)
          if (slideIndex > 0 && slides[slideIndex]) {
              const slide = slides[slideIndex];
              
              // Try different approaches - use the one that works
              // OPTION 1: CSS class (if you have CSS for it)
              slide.classList.add('cstm_iPhone_margin');
              
              // OPTION 2: Direct transform (more reliable)
              // Adjust this value based on what looks centered
              slide.style.transform = 'translateX(-7.5px)'; // The exact offset from logs
              
              // OPTION 3: Direct margin
              // slide.style.marginLeft = '-7.5px';
          }
      }

      // Updated iosGoToSlide for pixel perfection
      function iosGoToSlide(index, slider, slides) {
          if (index < slides.length && index >= 0) {
              iosAlignmentLock = true;
              
              // Remove all adjustments first
              Array.from(slides).forEach(slide => {
                  slide.classList.remove('cstm_iPhone_margin');
                  slide.style.transform = '';
              });
              
              // For first slide: scroll to 0
              // For other slides: use exact offset positions from your logs
              let targetScroll;
              if (index === 0) {
                  targetScroll = 0;
              } else {
                  // Use the exact values from your console logs:
                  // Slide 1: 377px, Slide 2: 754px, Slide 3: 1131px, etc.
                  targetScroll = index * 377; // 353px slide + 24px gap
              }
              
              console.log(`iOS: Jumping to slide ${index} at ${targetScroll}px`);
              
              // Scroll directly to position
              slider.scrollLeft = targetScroll;
              
              // Apply visual adjustment after scroll
              setTimeout(() => {
                  applyIOSVisualAdjustment(index);
                  iosAlignmentLock = false;
                  lastAlignmentTime = Date.now();
              }, 100);
          }
      }

      // Update scroll event listener to be less aggressive
      if (/iPhone|iPad|iPod/.test(navigator.platform)) {
          const slider = document.querySelector('.product__media-list');
          if (slider) {
              let scrollEndTimer;
              
              slider.addEventListener('scroll', function() {
                  clearTimeout(scrollEndTimer);
                  scrollEndTimer = setTimeout(() => {
                      // Only fix alignment if user isn't actively touching
                      if (!iosAlignmentLock) {
                          requestAnimationFrame(() => {
                              fixIOSSlideAlignment();
                          });
                      }
                  }, 150); // Wait for scroll to completely stop
              });
              
              // Initial alignment
              setTimeout(fixIOSSlideAlignment, 1000);
          }
      }
        // ========== END iOS SPECIFIC FIX ==========

        // Your existing touch event handlers...
        $('.template-product .product__media-list > li').each(function () {
            $(this).off('touchstart touchend');
            $(this).on('touchstart', function (event) {
                touchStartX = event.changedTouches[0].screenX;
                touchStartY = event.changedTouches[0].screenY;
            });
        
            $(this).on('touchend', function (event) {
                touchEndX = event.changedTouches[0].screenX;
                touchEndY = event.changedTouches[0].screenY;
                handleSwipeDirection();
            });
        });

        var touchStartX = 0;
        var touchEndX = 0;
        var touchStartY = 0;
        var touchEndY = 0;
        
        // Function to handle swiping direction
        function handleSwipeDirection() {
            var horizontalSwipeDistance = Math.abs(touchEndX - touchStartX);
            var verticalSwipeDistance = Math.abs(touchEndY - touchStartY);

            // Only proceed if the horizontal distance is greater than the vertical distance
            if (horizontalSwipeDistance > verticalSwipeDistance) {
                const slider = document.querySelector('.product__media-list');
                const slides = slider.children;
                
                // Check if iOS and apply iOS-specific logic
                const isIOS = /iPhone|iPad|iPod/.test(navigator.platform) && /iPhone/i.test(navigator.userAgent);

                // --- Swipe Left ---
                if (touchEndX < touchStartX) {
                    console.log('Swiped left');

                    // Move cstm_GPI items
                    var $cstmGPIs1 = $('.product__media-list li.cstm_GPI');
                    if ($cstmGPIs1.length > 0) {
                        var $firstLi1 = $('.product__media-list li').first();
                        $cstmGPIs1.insertAfter($firstLi1);
                    }

                    var $cstmGPIs2 = $('.thumbnail-list li.cstm_GPI');
                    if ($cstmGPIs2.length > 0) {
                        var $firstLi2 = $('.thumbnail-list li').first();
                        $cstmGPIs2.insertAfter($firstLi2);
                    }

                    // Move to the NEXT thumbnail
                    const currentThumb = document.querySelector('.template-product .thumbnail-list__item.slider__slide .thumbnail[aria-current]');
                    if (currentThumb) {
                        const currentLi = currentThumb.closest('li');
                        const allLis = Array.from(document.querySelectorAll('.thumbnail-list li'));
                        const currentIndex = allLis.indexOf(currentLi);
                        const nextIndex = currentIndex + 1;
                        
                        if (nextIndex < allLis.length) {
                            if (isIOS) {
                                // Use iOS-specific function
                                iosGoToSlide(nextIndex, slider, slides);
                            } else {
                                // Original Android logic
                                const scrollAmount = slides[nextIndex].offsetLeft;
                                slider.scrollTo({
                                    left: scrollAmount,
                                    behavior: 'smooth'
                                });
                            }
                        }
                    }
                }

                // --- Swipe Right ---
                if (touchEndX > touchStartX) {
                    console.log('Swiped right');

                    // Move cstm_GPI items
                    var $cstmGPIs1 = $('.product__media-list li.cstm_GPI');
                    if ($cstmGPIs1.length > 0) {
                        var $firstLi1 = $('.product__media-list li').first();
                        $cstmGPIs1.insertAfter($firstLi1);
                    }

                    var $cstmGPIs2 = $('.thumbnail-list li.cstm_GPI');
                    if ($cstmGPIs2.length > 0) {
                        var $firstLi2 = $('.thumbnail-list li').first();
                        $cstmGPIs2.insertAfter($firstLi2);
                    }

                    // Move to the PREVIOUS thumbnail
                    const currentThumb = document.querySelector('.template-product .thumbnail-list__item.slider__slide .thumbnail[aria-current]');
                    if (currentThumb) {
                        const currentLi = currentThumb.closest('li');
                        const allLis = Array.from(document.querySelectorAll('.thumbnail-list li'));
                        const currentIndex = allLis.indexOf(currentLi);
                        const nextIndex = currentIndex - 1;
                        
                        if (nextIndex >= 0) {
                            if (isIOS) {
                                // Use iOS-specific function
                                iosGoToSlide(nextIndex, slider, slides);
                            } else {
                                // Original Android logic
                                const scrollAmount = slides[nextIndex].offsetLeft;
                                slider.scrollTo({
                                    left: scrollAmount,
                                    behavior: 'smooth'
                                });
                            }
                        }
                    }
                }
                
                // Apply iOS alignment fix after swipe
                if (isIOS) {
                    setTimeout(fixIOSSlideAlignment, 500);
                }
            }
        }
        
        // Add scroll listener for iOS to continuously check alignment
        if (/iPhone|iPad|iPod/.test(navigator.platform) && /iPhone/i.test(navigator.userAgent)) {
            const slider = document.querySelector('.product__media-list');
            if (slider) {
                let scrollTimeout;
                slider.addEventListener('scroll', function() {
                    clearTimeout(scrollTimeout);
                    scrollTimeout = setTimeout(fixIOSSlideAlignment, 150);
                });
                
                // Initial alignment check
                setTimeout(fixIOSSlideAlignment, 1000);
            }
        }
    }
    
  }   

  $('.cstm_featured_coll .quick-add button').click(function(e) {
    e.preventDefault();
    var proURL = $(this).parent().parent().parent().parent().find('a').attr('href');
    window.location.href = proURL;
  });

  var relatedProdSlider = $('.cstm-related-products .grid').slick({
    infinite: false,
    dots: true,
    arrows: false,
    adaptiveHeight: true,
    slidesToShow: 1,
    slidesToScroll: 1
  });

  var urlParams = new URLSearchParams(window.location.search);
  var variantId = urlParams.get('variant');
  
  if (variantId) {
      var variantsData = JSON.parse(document.querySelector('variant-selects script[type="application/json"]').textContent);
      var matchingVariant = variantsData.find(variant => variant.id === parseInt(variantId, 10));
      if (matchingVariant) {
          console.log("Option Names for Variant ID", variantId, ":", matchingVariant.options);
          var optionNames = matchingVariant.options;
          var fieldsets = document.querySelectorAll('.product__info-container > variant-selects fieldset');
          var delay = 0;
          optionNames.forEach((optionName, index) => {
              setTimeout(() => {
                  var input = fieldsets[index].querySelector(`input[type="radio"][value="${optionName}"]`);
                  if (input) {
                      input.click();
                      console.log(`Selected option in fieldset ${index + 1}: ${optionName}`);
                  } else {
                      console.log(`Option not found in fieldset ${index + 1}: ${optionName}`);
                  }
              }, delay);
  
              delay += 500;
          });
  
      } else {
          console.log("No matching variant found for ID:", variantId);
      }
  } else {
      var length = document.querySelectorAll('.product__info-container > variant-selects .product-form__input').length;
      for (let i = 0; i < length; i++) {
        setTimeout(() => {
          document.querySelectorAll('.product__info-container > variant-selects .product-form__input')[i]
            .querySelector('input')
            .click();
        }, i * 500);
      }

  }


  // $('.cstm_var_sel_wrapper').removeClass('cstm_notAvailable');

});


  function customizeClick(element, event) {
    event.preventDefault();
  
    // Hide the clicked button
    element.style.display = 'none';
  
    // Show the next sibling element
    var nextSibling = element.nextElementSibling;
    if (nextSibling) {
        nextSibling.style.display = 'block';
    }

    var clickIndex = element.getAttribute('data-index');
    if(document.querySelector(`.cstm_related_prod_variants_wrapeper[data-index="${clickIndex}"]`)) {
      document.querySelector(`.cstm_related_prod_variants_wrapeper[data-index="${clickIndex}"]`).style.display = 'flex';
    }
  
    // // Get the current slide index of the related product slider
    // var currentSlideIndex = relatedProdSlider.slick('slickCurrentSlide');
  
    // // Move the slider to the current slide index
    // relatedProdSlider.slick('slickGoTo', currentSlideIndex);
  }

  // Inline function for handling select change
  function updateVariant(selectElement) {
    var clickIndex = selectElement.getAttribute('data-index');
    var selectElements = document.querySelectorAll(`.cstm_related_prod_variants_wrapeper[data-index="${clickIndex}"] .cstm_related_prod_variants_inner select`);
    var valuesArray = [];
    
    // Loop through the NodeList and collect the values
    selectElements.forEach(function(selectElement) {
        valuesArray.push(selectElement.value);
    });
    
    // Concatenate the values with " / " separator
    var concatenatedValues = valuesArray.join(' / ');

    var options = document.querySelectorAll(`.cstm_recommended_accessories_variants[data-index="${clickIndex}"] option`);

    options.forEach(function(option) {
      if (option.textContent === concatenatedValues) {
          option.selected = true;
      } else {
          option.selected = false;
      }
    });

    // Get the dropdown element
    var dropdownSelected = document.querySelector(`.cstm_recommended_accessories_variants[data-index="${clickIndex}"]`);
    
    // Get the selected option
    var selectedOption = dropdownSelected.options[dropdownSelected.selectedIndex];
    
    // Check if the selected option is disabled
    if (selectedOption.disabled) {
        console.log('The selected option is disabled.');
        var errorDiv = document.createElement('div');
        errorDiv.className = 'cstm_error';
        errorDiv.textContent = 'This variant option is out of stock. Please select another one.';
        var cardWrapper = document.querySelector(`.card-wrapper[data-index="${clickIndex}"]`);
        if (!cardWrapper.querySelector('.cstm_error')) {
            cardWrapper.appendChild(errorDiv);
        }
    } else {
        const errorEl = document.querySelector(
          `.card-wrapper[data-index="${clickIndex}"] .cstm_error`
        );

        if (errorEl) {
          errorEl.remove();
        }

        var selectedVal = document.querySelector(`.cstm_recommended_accessories_variants[data-index="${clickIndex}"]`).value;
        document.querySelector(`.cstm_add_cart[data-index="${clickIndex}"]`).setAttribute('data-variant-id', selectedVal);
    }

  }
  
  // Inline function for handling button click
  function addToCart(buttonElement, event) {
    event.preventDefault();
      var varID = buttonElement.getAttribute('data-variant-id');
      var data = {
          "id": varID,
          "quantity": 1
      };
  
      jQuery.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: data,
          dataType: 'json',
          success: function(response) { 
              console.log('Product added to cart:', response);
              fetch(`${routes.cart_url}?section_id=cart-drawer`)
                  .then((response) => response.text())
                  .then((responseText) => {
                      const html = new DOMParser().parseFromString(responseText, 'text/html');
                      const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
                      for (const selector of selectors) {
                          const targetElement = document.querySelector(selector);
                          const sourceElement = html.querySelector(selector);
                          if (targetElement && sourceElement) {
                              targetElement.replaceWith(sourceElement);
                          }
                      }
                      // If needed, reinitialize additional JS
                          var relatedProdSlider = $('.cstm-related-products .grid').slick({
                          infinite: false,
                          dots: true,
                          arrows: false,
                          adaptiveHeight: true,
                          slidesToShow: 1,
                          slidesToScroll: 1
                        });
                      relatedProdSlider.slick('refresh');
                  })
                  .catch((e) => {
                      console.error(e);
                  });
          }
      });
  }

  function soldOut(element, event) {
    event.preventDefault();
  }




document.addEventListener("DOMContentLoaded", function () {
  const cards = document.querySelectorAll('.video-card');
  const modal = document.getElementById('video-modal');
  const closeBtn = document.querySelector('.modal-close');
  const modalTitle = document.getElementById('modal-title');
  const youtubePlayer = document.getElementById('youtube-video-player');
  const shopifyPlayer = document.getElementById('shopify-video-player');
  const modalDescription = document.getElementById('modal-description');
  const modalProductsGrid = document.getElementById('modal-products-grid');

  // Function to load product cards
  async function loadProductCards(productIds) {
    if (!productIds || productIds.length === 0 || !modalProductsGrid) return;
    
    try {
      const response = await fetch(`/products.json?ids=${productIds.join(',')}`);
      const { products } = await response.json();
      
      modalProductsGrid.innerHTML = '';
      
      products.forEach(product => {
        const productCard = document.createElement('li');
        productCard.className = 'grid__item';
        
        const firstVariant = product.variants[0];
        const price = Shopify.formatMoney(firstVariant.price, '{{ shop.money_format }}');
        
        productCard.innerHTML = `
          <div class="modal-product-card">
            <a href="${product.url}">
              <img src="${product.images[0]?.src || '//cdn.shopify.com/s/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_large.gif'}" 
                  alt="${product.title}" 
                  class="modal-product-image"
                  loading="lazy">
            </a>
            <div class="modal-product-info">
              <h3 class="modal-product-title">
                <a href="${product.url}">${product.title}</a>
              </h3>
              <div class="modal-product-price">${price}</div>
            </div>
          </div>
        `;
        
        modalProductsGrid.appendChild(productCard);
      });
    } catch (error) {
      console.error('Error loading products:', error);
    }
  }

  cards.forEach(card => {
    card.addEventListener('click', () => {
      if (!modal || !modalTitle || !modalDescription) return;
      
      const title = card.getAttribute('data-title');
      const videoType = card.getAttribute('data-video-type');
      const videoUrl = card.getAttribute('data-video');
      const shopifyVideoUrl = card.getAttribute('data-shopify-video');
      const desc = card.getAttribute('data-description');
      const relatedProducts = card.getAttribute('data-related-products')?.split(',').filter(Boolean) || [];

      modalTitle.textContent = title;
      modalDescription.innerHTML = desc;

      // Hide both players first
      if (youtubePlayer) youtubePlayer.style.display = 'none';
      if (shopifyPlayer) shopifyPlayer.style.display = 'none';

      if (videoType === 'shopify' && shopifyVideoUrl && shopifyPlayer) {
        // Play Shopify video
        shopifyPlayer.src = shopifyVideoUrl;
        shopifyPlayer.style.display = 'block';
        shopifyPlayer.play();
      } else if (videoUrl && youtubePlayer) {
        // Play YouTube video
        const youtubeEmbedUrl = videoUrl.includes('youtube.com') 
          ? videoUrl.replace("watch?v=", "embed/").replace("youtu.be/", "youtube.com/embed/")
          : `https://www.youtube.com/embed/${videoUrl.split('v=')[1]}`;
        youtubePlayer.src = youtubeEmbedUrl;
        youtubePlayer.style.display = 'block';
      }

      // Load related products
      if (modalProductsGrid) {
        if (relatedProducts.length > 0) {
          loadProductCards(relatedProducts);
        } else {
          modalProductsGrid.innerHTML = '<p>No related products found</p>';
        }
      }

      modal.classList.add('active');
      document.body.style.overflow = 'hidden';
    });
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      if (!modal) return;
      
      modal.classList.remove('active');
      if (youtubePlayer) youtubePlayer.src = '';
      if (shopifyPlayer) shopifyPlayer.src = '';
      document.body.style.overflow = 'auto';
      
      // Pause the video when closing
      if (shopifyPlayer && shopifyPlayer.style.display === 'block') {
        shopifyPlayer.pause();
      }
    });
  }

  // Close modal when clicking outside content
  if (modal) {
    modal.addEventListener('click', (e) => {
      if (e.target === modal && closeBtn) {
        closeBtn.click();
      }
    });
  }










//  if (document.querySelector('.search-bar')) {
//   document.querySelector('.search-bar').addEventListener('input', function (event) {
//     event.preventDefault();
//     let query = this.value.toLowerCase().trim(); // Search query
//     let sections = document.querySelectorAll('.video-grid'); // All sections

//     // If query is empty, show all sections/products and remove 'grid-ps' class
//     if (query === "") {
//       sections.forEach(function (section) {
//         section.style.display = 'grid';
//         section.classList.remove('grid-ps'); // 🔴 Remove class when input is empty

//         let products = section.querySelectorAll('.video-card');
//         products.forEach(function (product) {
//           product.style.display = 'grid';
//         });
//       });
//       return; // Stop further execution
//     }

//     // If query is not empty, do filtering and add 'grid-ps' class
//     sections.forEach(function (section) {
//       let products = section.querySelectorAll('.video-card');
//       let hasVisibleProduct = false;

//       products.forEach(function (product) {
//         let productName = product.querySelector('.video-card-title').textContent.toLowerCase();

//         if (productName.includes(query)) {
//           product.style.display = 'grid';
//           hasVisibleProduct = true;
//         } else {
//           product.style.display = 'none';
//         }
//       });

//       if (hasVisibleProduct) {
//         section.style.display = 'grid';
//         section.classList.add('grid-ps'); // ✅ Add class when matches found
//       } else {
//         section.style.display = 'none';
//         section.classList.remove('grid-ps'); // ❌ Remove class when no match
//       }
//     });
//   });
// }










  

  
  
});




$(function () {
    const $compatibleWidthSec = $('.cstm_compatible_coll_sec .quick-add product-form');

    if ($compatibleWidthSec.length) {
      $compatibleWidthSec.on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const variantId = $(this).find('button[type="submit"]').data('variant-id');
        if (!variantId) {
          console.error('No data-variant-id found on button');
          return;
        }

        const data = {
          id: variantId,
          quantity: 1
        };

        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: data,
          dataType: 'json',
          success: function (response) {
            console.log('Product added to cart:', response);

            fetch(`${routes.cart_url}?sections=cart-drawer`)
            .then((response) => response.json())
            .then((sections) => {
              const sectionIds = ['cart-drawer'];
              for (const sectionId of sectionIds) {
                const htmlString = sections[sectionId];
                const html = new DOMParser().parseFromString(htmlString, 'text/html');
                const sourceElement = html.querySelector(`${sectionId}`);
                const targetElement = document.querySelector(`${sectionId}`);
                if (targetElement && sourceElement) {
                  targetElement.replaceWith(sourceElement);
                }
              }
              document.body.classList.add('overflow-hidden');
              const theme_cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
              if (theme_cart && theme_cart.classList.contains('is-empty')) theme_cart.classList.remove('is-empty');
              theme_cart.classList.add('active');
              theme_cart.classList.add('animate');

              const $relatedProdSlider = $('.cstm-related-products .grid');
              if ($relatedProdSlider.hasClass('slick-initialized')) {
                $relatedProdSlider.slick('unslick');
              }

              $relatedProdSlider.slick({
                infinite: false,
                dots: true,
                arrows: false,
                adaptiveHeight: true,
                slidesToShow: 1,
                slidesToScroll: 1
              }).slick('refresh');

            })
            .catch((e) => {
              console.error('Error updating cart sections:', e);
            });
          },
          error: function (xhr, status, error) {
            console.error('Error adding to cart:', error);
          }
        });
      });
    }
});